<template>
  <vs-popup
    class="rm-batch-attachments-popup"
    :title="`ATTACHMENTS - ${batchCode}`"
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <vx-card no-shadow :card-border="true" class="mt-4">
          <h6 class="font-semibold text-base mb-2 pb-2 border-b">
            Attachments
          </h6>

          <FilePreviewGallery
            :files="filePaths"
            @remove="removeFile"
            :removable="true"
            class="mb-2"
          />

          <multi-file-uploader
            v-on:onSetFileName="onSetFiles($event)"
            :file="''"
            file_path="taste-panel/attachments"
            :condition="true"
          />
        </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";

import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue";
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
 const InventoryRepository = RepositoryFactory.get('inventory');

export default {
  name: "RmBatchTastePanelAttachments",
  data() {
    return {
      open: false,
      id: null,
      attachments: {},
      batchCode: "",
      filePaths: [],
    };
  },
  components: {
    FilePreviewGallery,
  },
  methods: {
    async openPopup(id, batchCode) {
      this.id = id;
      this.batchCode = batchCode;
      this.open = true;
      await this.getTastingGroupFiles();
    },
    async getTastingGroupFiles() {
      try {
        const response = await InventoryRepository.getRawMaterialInventoryFilePath(
          this.id
        );
        this.filePaths = response.data.data ? response.data.data : []
      } catch (e) {
      }
    },

    async removeFile(index) {
      this.filePaths.splice(index, 1);
      await this.updateTastingGroupFiles();
    },

    async onSetFiles(file_path) {
      this.filePaths.push(file_path);
      await this.updateTastingGroupFiles();
    },

    async updateTastingGroupFiles() {
      const payload = {
        file_paths: this.filePaths,
      };
      try {
        await InventoryRepository.updateInventoryFilePaths(
          this.id,
          payload
        );
      } catch (error) {}
    },

    closePopup() {
      this.open = false;
      this.id = null;
      this.batchCode = "";
    },
  },
};
</script>
<style scoped>
.rm-batch-attachments-popup >>> .vs-popup {
  min-width: 50% !important;
}
</style>
